if (!customElements.get("localization-form-language")) {
  class LocalizationFormLang extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
        form: this.querySelector('form'),
        details: this.closest('details'),
        summary: this.closest('details')?.querySelector('summary'),
      };

      this.details = this.closest('.localization-selector-mobile');
      this.input = this.querySelector('input[name="language_code"], input[name="country_code"]');

      this.querySelectorAll('a').forEach(item => {
        item.addEventListener('click', this.onItemClick.bind(this));
      });

      if (this.details) {
        this.details.addEventListener('toggle', () => {
          if (this.details.open) {
            this.details.setAttribute('aria-expanded', 'true');
            // Delay prevents the opening click from immediately triggering close
            setTimeout(() => {
              document.addEventListener('click', this.onDocumentClick);
              document.addEventListener('keyup', this.onEscapeKey);
            }, 0);
          } else {
            this.details.setAttribute('aria-expanded', 'false');
            document.removeEventListener('click', this.onDocumentClick);
            document.removeEventListener('keyup', this.onEscapeKey);
          }
        });
      }
    }

    onDocumentClick = (event) => {
      if (!this.details.contains(event.target)) {
        this.details.open = false;
      }
    }

    onEscapeKey = (event) => {
      if (event.key === 'Escape') {
        this.details.open = false;
      }
    }

    onItemClick(event) {
      event.preventDefault();
      if (this.elements.form && this.elements.input) {
        this.input = this.elements.input;
        this.input.value = event.currentTarget.dataset.value;
        this.elements.form.submit();
      }
    }

    close() {
      if (this.elements.details && this.elements.details.hasAttribute('open')) {
        this.elements.details.removeAttribute('open');
        this.elements.details.setAttribute('aria-expanded', 'false');
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keyup', this.onEscapeKey);
    }
  }

  customElements.define('localization-form-language', LocalizationFormLang);
}
